const InvalidPage = () => {
  return (
    <div>
      <h2>Oops! This page does not exist ;w;</h2>
    </div>
  );
}

export default InvalidPage;